module.exports = __webpack_public_path__ + "img/num3.71cefaec.png";